export default __webpack_public_path__ + "img/widget-close.e71de6ac.svg";